import styled from "../styles/styled"

const Paragraph = styled("p")((props, { scale }) => ({
  fontWeight: 700,
  fontSize: scale({ mobile: 20 }, { mobileMd: 20, tablet: 24 }, { tablet: 24 }),
  lineHeight: 1.45
}))

export default Paragraph
